// Generated by https://quicktype.io

import {IFormTypeMappingHelper} from "./IMappedFormHelper"
import {IUnsavedRelativeRiskAssessment} from "./IRelativeRiskAssessment"

export interface IAnalysis {
    analysisId: number;
    assumptionsAndLimitations?: string;
    createdDate?: number | string;
    /**@description for backend, this property must be populated unless hasNoExpiration is true */
    expirationDate?: number;
    /**@description for backend, this property cannot be null, omitted, or false unless expirationDate is populated */
    hasNoExpiration?: boolean;
    modelType: string;
    notes?: string;
    /**@description Required to save an analysis request. Description of an analysis request to be populated by requestor. Informs analyst as to what the requestor wants from the analysis. */
    requestDescription?: string;
    requestedByUser?: string,
    assignedAnalyst?: string,
    startDate: number | string;
    status: AnalysisStatus;
    statusModifiedDate?: number;
    statusModifiedUser?: string;
    title: string;
    wfdssCaseId: number;
    fspro: FsPro;
    isIncludedInDecision?: boolean;
}
export type FsPro = {
    fsproId?: number | null;
    numberOfFires: number;
    numberOfDays: number;
    crownFireMethod?: CrownFireMethod | null;
    ignitionFileName?: string | null;
    barrierFileName?: string | null;
    isBarrierFilled?: boolean | null;
    resolution?: null | number
};
export type CrownFireMethod = "Finney" | "ScottReinhardt"

export type UserAssignedStatuses = "Completed For Operational Use" | "Completed For Strategic Use" | "Calibration" | "Reference";
export type SystemAssignedStatuses = "Assigned" | "Requested" | "Processing" | "Successful Run" | "Terminated" | "Failed" | "Review";
export type AnalysisStatus = UserAssignedStatuses | SystemAssignedStatuses;
// May delete these, undecided
export const analysisStatuses: AnalysisStatus[] = ["Assigned", "Requested", "Processing", "Successful Run", "Terminated", "Failed", "Review", "Completed For Operational Use", "Completed For Strategic Use", "Calibration", "Reference"];
export class StatusRules {
    private allowedMap = new Map<AnalysisStatus, AnalysisStatus[]>();
    public systemAssignedStatuses: SystemAssignedStatuses[] = ["Assigned", "Requested", "Processing", "Successful Run", "Terminated", "Failed", "Review"];
    public userAssignedStatuses: UserAssignedStatuses[] = ["Completed For Operational Use", "Completed For Strategic Use", "Calibration", "Reference"];

    constructor() {
        this.allowedMap.set("Requested", ["Assigned"]);
        this.allowedMap.set("Assigned", ["Processing"]);
        this.allowedMap.set("Terminated", ["Assigned"]);
        this.allowedMap.set("Failed", ["Assigned"]);
        this.allowedMap.set("Processing", ["Failed", "Terminated", "Review"]);
        this.allowedMap.set("Successful Run", ["Review", "Completed For Operational Use", "Completed For Strategic Use"]);
        this.allowedMap.set("Review", [...this.userAssignedStatuses]);
        this.allowedMap.set("Completed For Operational Use", ["Completed For Strategic Use"]);
        this.allowedMap.set("Completed For Strategic Use", ["Completed For Operational Use"]);
        this.allowedMap.set("Calibration", ["Completed For Operational Use", "Completed For Strategic Use", "Reference"]);
        this.allowedMap.set("Reference", ["Completed For Operational Use", "Completed For Strategic Use", "Calibration"]);
    }
    /**@description checks to see if an analysis status change complies with business logic rules */
    isStatusChangeAllowed(currentStatus: AnalysisStatus, nextStatus: AnalysisStatus): boolean {
        // if(currentStatus == undefined || nextStatus == undefined) return true
        if (currentStatus === nextStatus) return true;
        return this.allowedMap.get(currentStatus).includes(nextStatus);
    }
}
/**
 * @description Not to be confused with the actual data model, IAnalysis.
 * This interface is used to store read only/display only properties.
 * If you're using integrating this object into forms or data mapping, you're probably doing something wrong.
 */
export interface IUIAnalysisModel{
    name:string;
    modelType: UIAnalysisModelType,
    pixelLimit: number;
}
export interface IAnalysisSummary {
    analysisSummaryId?: number | null | undefined;
    summaryText?: string | null | undefined;
    wfdssCaseId?: number | null | undefined;
    readyForPublication?: boolean | null | undefined;
    doNotIncludeAnyAnalysis?: boolean | null | undefined;
}
export interface AnalysisSummaryForm
    extends IFormTypeMappingHelper<IAnalysisSummary> {}
/**
 * @description Not to be confused with the actual data model.
 * This interface is used to store read only/display only properties.
 * If you're using integrating this object into forms or data mapping, you're probably doing something wrong.
 */
export class UIFSPro implements IUIAnalysisModel {
    name = "FSPro"
    modelType : "FSPro" = "FSPro"
    pixelLimit = 2500000
}
/**
 * @description Not to be confused with the actual data model.
 * This interface is used to store read only/display only properties.
 * If you're using integrating this object into forms or data mapping, you're probably doing something wrong.
 */
export class UIFlamMapBasic implements IUIAnalysisModel {
    name = "FlamMap (Basic)"
    modelType : "FlamMap (Basic)" = "FlamMap (Basic)"
    pixelLimit = 12000000
}
/**
 * @description Not to be confused with the actual data model.
 * This interface is used to store read only/display only properties.
 * If you're using integrating this object into forms or data mapping, you're probably doing something wrong.
 */
export class UIMTTShortTerm implements IUIAnalysisModel {
    name = "MTT (ShortTerm)"
    modelType : "MTT" = "MTT"
    pixelLimit = 12000000
}
/**
 * @description Not to be confused with the actual data model.
 * This interface is used to store read only/display only properties.
 * If you're using integrating this object into forms or data mapping, you're probably doing something wrong.
 */
export class UIFarsite implements IUIAnalysisModel {
    name = "FARSITE (NearTerm)"
    modelType : "FARSITE" = "FARSITE" // in backend modeType value is 'FARSITE' (in lower case though which backend will handle) and not 'FARSITE (NearTerm)' as was previously
    pixelLimit = 12000000
}
export type UIAnalysisModelType = "FSPro" | "FlamMap (Basic)" | "MTT" | "FARSITE"
export const AnalysisModelTypes: IUIAnalysisModel[] = [new UIFlamMapBasic(),new UIMTTShortTerm(),new UIFarsite(),new UIFSPro()]
